import React, {Component} from 'react';
// import withRecognizerForMemorizeB from "./withRecognizerForMemorizeB";
import withRecognizerDialogue from "./withRecognizerDialogue";
import MicVisualizer from "../other/MicVisualizer";
import {scroller} from "react-scroll";
import {isMobile} from "../../asset/js/myFunctions";
import $ from "jquery";


class Footer_RDA extends Component {

    constructor(props) {
        super(props);
        this.state = {
            index: 999,
            recording: false,
            audioURL: null,
        };
        this.endRecognitionTimer = null;

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.listening && !this.props.listening) {
            this._clearEndRecognitionTimer();
        }

        if (!prevProps.letStartRecognition && this.props.letStartRecognition) {
            const content = this.props.contents && this.props.contents[this.props.currentIndex];

            if(!content) {
                return;
            }

            this.props.startRecognition();
            if (this.props.serverData.user_kind === "K") {
                this._scheduleEndRecognition(content.eng_content.length * 200);
            } else if(this.props.serverData.step_code === "L3"){
                this._scheduleEndRecognition(1 + content.eng_content.length * 110);
            }
        }
    }

    componentWillUnmount() {
        this._clearEndRecognitionTimer();
    }

    render() {
        if(this.props.showContinue){
            return(
                <section className="view-footer">
                    <button
                        type="button"
                        className="f-btn f-center btn-test"
                        onClick={() => {
                            this.props.resetAudioContext();
                            this.props.closeTip();
                        }}>파이널 테스트
                    </button>
                </section>
            )
        }
        return (
            <section className="view-footer">
                <button type="button" className="f-btn">Empty</button>
                {
                    this.props.isPlaying ?
                        <button
                            type="button"
                            className="f-btn f-center btn-listen"
                        > 듣는중</button>
                        :
                        this.props.err === null ?
                            this.props.listening ?
                                <MicVisualizer/>
                                :
                                this.props.waiting ?
                                    ""
                                    :
                                    <button
                                        type="button"
                                        className="f-btn f-center btn-test"
                                        onClick={() => {
                                            //this.props.goNextMenu()
                                            // this._memorizeAFinalTest();
                                            this.props.memorizeAFinalTest(0)
                                        }}>파이널 테스트 재시작
                                    </button>
                            :
                            this.props.isTesting ?
                                <button
                                    type="button"
                                    className="f-btn f-center btn-test"
                                    onClick={() => {
                                        //this.props.goNextMenu()
                                        const content = this.props.contents && this.props.contents[this.props.currentIndex];

                                        if(!content) {
                                            return;
                                        }

                                        this.props.startRecognition();
                                        if (this.props.serverData.user_kind === "K") {
                                            this._scheduleEndRecognition(content.eng_content.length * 200);
                                        } else if(this.props.serverData.step_code === "L3"){
                                            this._scheduleEndRecognition(1 + content.eng_content.length * 110);
                                        }
                                        this.props.handleError(null);
                                        this.props.closeTip();
                                    }}>재시작
                                </button>
                                :
                                <button
                                    type="button"
                                    className="f-btn f-center btn-test"
                                    onClick={() => {
                                        //this.props.goNextMenu()
                                        // this._memorizeAFinalTest();
                                        this.props.memorizeAFinalTest(0);
                                        this.props.closeTip();
                                    }}>파이널 테스트
                                </button>
                }
                {
                    this.props.isComplete && this.props.pass ?
                        <button type="button" className="f-btn btn-next-page" onClick={() => this.props.goNextMenu()}>
                            다음메뉴
                        </button> : <button type="button" className="f-btn">Empty</button>
                }

            </section>

        );
    }

    _scheduleEndRecognition = (duration) => {
        this._clearEndRecognitionTimer();
        this.endRecognitionTimer = setTimeout(() => {
            this.props.endRecognition();
            this.endRecognitionTimer = null;
        }, duration);
    }

    _clearEndRecognitionTimer = () => {
        if(this.endRecognitionTimer !== null) {
            clearTimeout(this.endRecognitionTimer);
            this.endRecognitionTimer = null;
        }
    }

}

export default withRecognizerDialogue()(Footer_RDA);

    
